import { ObjectFieldDTO } from '@types'

export const getLabelScriptConfig = (selectedObjectFields: ObjectFieldDTO[]) => {
  return {
    fieldsInfo: selectedObjectFields.map(field => {
      return {
        key: `srcObj.${field.name}`,
        name: field.desc as string,
        objectCode: 'context',
      }
    }),
    variables: [
      {
        name: 'srcObj',
        type: selectedObjectFields.map(field => {
          return {
            name: field.name,
            type: field.valueType,
            description: field.desc as string,
          }
        }),
      },
    ],
  }
}
